"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazyLoaders = exports.loaders = exports.loadersPlugin = void 0;
var kea_1 = require("kea");
var loadersPlugin = function (options) {
    if (options === void 0) { options = {}; }
    return {
        name: 'loaders',
        events: {
            afterPlugin: function () {
                var _a, _b, _c;
                var pluginContext = (0, kea_1.getPluginContext)('loaders');
                pluginContext.onStart = (_a = options.onStart) !== null && _a !== void 0 ? _a : (function () { });
                pluginContext.onSuccess = (_b = options.onSuccess) !== null && _b !== void 0 ? _b : (function () { });
                pluginContext.onFailure =
                    (_c = options.onFailure) !== null && _c !== void 0 ? _c : function (_a) {
                        var error = _a.error, actionKey = _a.actionKey, reducerKey = _a.reducerKey, logic = _a.logic;
                        console.error("Error in ".concat(actionKey, " for ").concat(reducerKey, ":"), error);
                    };
            },
            legacyBuildAfterDefaults: function (logic, input) {
                'loaders' in input && input.loaders && loaders(input.loaders)(logic);
            },
        },
    };
};
exports.loadersPlugin = loadersPlugin;
function loaders(input, opts) {
    var _a;
    var lazy = (_a = opts === null || opts === void 0 ? void 0 : opts.lazy) !== null && _a !== void 0 ? _a : false;
    return function (logic) {
        var loaders = typeof input === 'function' ? input(logic) : input;
        var _loop_1 = function (reducerKey, actionsInput) {
            var defaultValue = logic.defaults[reducerKey];
            var actionsObject = actionsInput;
            if (Array.isArray(actionsObject)) {
                if (typeof defaultValue === 'undefined') {
                    defaultValue = actionsObject[0];
                }
                actionsObject = actionsObject[1] || {};
            }
            var _c = actionsObject, __default = _c.__default, loaderActions = __rest(_c, ["__default"]);
            if (typeof defaultValue === 'undefined' && typeof __default !== 'undefined') {
                defaultValue = typeof __default === 'function' ? __default() : __default;
            }
            if (typeof defaultValue === 'undefined') {
                defaultValue = null;
            }
            var newActions = {};
            Object.keys(loaderActions).forEach(function (actionKey) {
                if (typeof logic.actions["".concat(actionKey)] === 'undefined') {
                    newActions["".concat(actionKey)] = function (params) { return params; };
                }
                if (typeof logic.actions["".concat(actionKey, "Success")] === 'undefined') {
                    newActions["".concat(actionKey, "Success")] = function (value, payload) {
                        var _a;
                        return (_a = { payload: payload }, _a[reducerKey] = value, _a);
                    };
                }
                if (typeof logic.actions["".concat(actionKey, "Failure")] === 'undefined') {
                    newActions["".concat(actionKey, "Failure")] = function (error, errorObject) { return ({ error: error, errorObject: errorObject }); };
                }
            });
            var newReducers = {};
            var reducerObject = {};
            var reducerLoadingObject = {};
            var firstActionKey = undefined;
            Object.keys(loaderActions).forEach(function (actionKey) {
                if (!firstActionKey) {
                    firstActionKey = actionKey;
                }
                reducerObject["".concat(actionKey, "Success")] = function (_, _a) {
                    var _b = reducerKey, value = _a[_b];
                    return value;
                };
                reducerLoadingObject["".concat(actionKey)] = function () { return true; };
                reducerLoadingObject["".concat(actionKey, "Success")] = function () { return false; };
                reducerLoadingObject["".concat(actionKey, "Failure")] = function () { return false; };
            });
            var baseReducerName = lazy ? "".concat(reducerKey, "Source") : reducerKey;
            if (typeof logic.reducers[reducerKey] === 'undefined') {
                newReducers[baseReducerName] = [defaultValue, reducerObject];
            }
            else {
                newReducers[baseReducerName] = reducerObject;
            }
            if (typeof logic.reducers["".concat(reducerKey, "Loading")] === 'undefined') {
                newReducers["".concat(reducerKey, "Loading")] = [false, reducerLoadingObject];
            }
            var newSelectors = {};
            if (lazy && firstActionKey) {
                newSelectors[reducerKey] = [
                    function (s) { return [s[baseReducerName]]; },
                    function (value) {
                        if (!logic.cache["lazyLoaderCalled-".concat(firstActionKey)]) {
                            try {
                                setTimeout(function () { var _a, _b; return firstActionKey && ((_b = (_a = logic.actions)[firstActionKey]) === null || _b === void 0 ? void 0 : _b.call(_a)); }, 0);
                            }
                            catch (e) {
                                console.error('[KEA-LAZY-LOADERS]', reducerKey, e);
                            }
                            logic.cache["lazyLoaderCalled-".concat(firstActionKey)] = true;
                        }
                        return value;
                    }
                ];
            }
            var newListeners = {};
            Object.entries(loaderActions).forEach(function (_a) {
                var actionKey = _a[0], listener = _a[1];
                newListeners[actionKey] = function (payload, breakpoint, action) {
                    var _a = (0, kea_1.getPluginContext)('loaders'), onStart = _a.onStart, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                    try {
                        onStart && onStart({ actionKey: actionKey, reducerKey: reducerKey, logic: logic });
                        var response_1 = listener(payload, breakpoint, action);
                        if (response_1 && response_1.then && typeof response_1.then === 'function') {
                            return response_1
                                .then(function (asyncResponse) {
                                onSuccess && onSuccess({ response: asyncResponse, actionKey: actionKey, reducerKey: reducerKey, logic: logic });
                                logic.actions["".concat(actionKey, "Success")](asyncResponse, payload);
                            })
                                .catch(function (error) {
                                if (!(0, kea_1.isBreakpoint)(error)) {
                                    onFailure && onFailure({ error: error, actionKey: actionKey, reducerKey: reducerKey, logic: logic, response: response_1 });
                                    logic.actions["".concat(actionKey, "Failure")](error.message, error);
                                }
                            });
                        }
                        else {
                            onSuccess && onSuccess({ response: response_1, actionKey: actionKey, reducerKey: reducerKey, logic: logic });
                            logic.actions["".concat(actionKey, "Success")](response_1, payload);
                        }
                    }
                    catch (error) {
                        if (!(0, kea_1.isBreakpoint)(error)) {
                            onFailure && onFailure({ error: error, actionKey: actionKey, reducerKey: reducerKey, logic: logic });
                            logic.actions["".concat(actionKey, "Failure")](error.message, error);
                        }
                    }
                };
            });
            (0, kea_1.actions)(newActions)(logic);
            (0, kea_1.reducers)(newReducers)(logic);
            if (lazy) {
                (0, kea_1.selectors)(newSelectors)(logic);
            }
            (0, kea_1.listeners)(newListeners)(logic);
        };
        for (var _i = 0, _a = Object.entries(loaders); _i < _a.length; _i++) {
            var _b = _a[_i], reducerKey = _b[0], actionsInput = _b[1];
            _loop_1(reducerKey, actionsInput);
        }
    };
}
exports.loaders = loaders;
function lazyLoaders(input) {
    return loaders(input, { lazy: true });
}
exports.lazyLoaders = lazyLoaders;
//# sourceMappingURL=index.js.map